import { createHttpClient, createSocket } from '@cascade/core/connection';
import { deployment } from '#config/index.ts';

export const llmSocket = createSocket({ url: deployment.llmUrl });

export const llmHttp = createHttpClient({ url: deployment.llmUrl });
